import type { CityConfig } from "../city-template/types";

export const fayettevilleConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Fayetteville",
  state: "North Carolina",
  stateAbbr: "NC",
  slug: "fayetteville",
  route: "/cities/fayetteville",
  title: "Emergency Passport Fayetteville, NC — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Fayetteville, NC — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Cumberland County and Fort Liberty area. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Fayetteville, NC",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Fayetteville and Fort Liberty area travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Beautiful%20aerial%20view%20of%20Fayetteville%20North%20Carolina%20downtown%20with%20historic%20Market%20House%20building%20and%20modern%20military%20cityscape%2C%20warm%20golden%20afternoon%20sunlight%2C%20lush%20green%20tree-lined%20streets%2C%20Fort%20Liberty%20military%20base%20visible%20in%20the%20distant%20background%2C%20clean%20blue%20sky%20with%20soft%20clouds%2C%20American%20flags%20and%20patriotic%20atmosphere%2C%20professional%20cityscape%20photography%20with%20vibrant%20warm%20colors%20and%20natural%20green%20landscape%2C%20no%20text%20or%20signs%20on%20buildings&width=1800&height=700&seq=fayetteville-hero-nc-001&orientation=landscape",
  heroImageAlt: "Fayetteville North Carolina downtown with historic Market House and Fort Liberty area",
  geoPosition: "35.0522;-78.8784",
  geoPlacename: "Fayetteville, North Carolina",
  regionalAgency: {
    name: "Washington DC Passport Agency",
    address: "600 19th St NW, Washington, DC 20006",
    distance: "Approximately 320 miles north of Fayetteville — about 5 hours via I-95",
  },
  nearbyCitiesZips: [
    { name: "Fayetteville", zips: "28301–28312, 28314" },
    { name: "Hope Mills", zips: "28348" },
    { name: "Spring Lake", zips: "28390" },
    { name: "Fort Liberty", zips: "28307, 28310" },
    { name: "Raeford", zips: "28376" },
    { name: "Stedman", zips: "28391" },
    { name: "Wade", zips: "28395" },
    { name: "Eastover", zips: "28312" },
    { name: "Linden", zips: "28356" },
    { name: "Autryville", zips: "28318" },
    { name: "Parkton", zips: "28371" },
    { name: "Lumberton", zips: "28358, 28359, 28360" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Fayetteville departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Cumberland County Hub", desc: "Serving Fayetteville, Fort Liberty, and the Sandhills region" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Raleigh, NC", route: "/cities/raleigh" },
    { name: "Fast passport renewal in Charlotte, NC", route: "/cities/charlotte" },
    { name: "Emergency passport help in Greensboro, NC", route: "/cities/greensboro" },
    { name: "Urgent passport services in Wilmington, NC", route: "/cities/wilmington" },
    { name: "Same-day passport help in Durham, NC", route: "/cities/durham" },
    { name: "Passport courier services in Jacksonville, NC", route: "/cities/jacksonville-nc" },
    { name: "Fast passport renewal in Goldsboro, NC", route: "/cities/goldsboro" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Fayetteville remotely via secure courier. We do not have a walk-in office in Fayetteville — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Cumberland County and the Sandhills region travelers.",
  fpcOfficeAddress: "301 Fayetteville St, Raleigh, North Carolina 27601",
  fpcOfficeDistance: "Serving all of Cumberland County and the Sandhills region including Fort Liberty and Hoke County",
  serviceAreaIntro: "From downtown Fayetteville to the military communities of Fort Liberty and Spring Lake, from Hope Mills to Raeford and Stedman — Fast Passport Center serves the entire Sandhills region. We regularly help military families and travelers from Wade, Eastover, and Linden get their passports fast.",
  nearbyCitiesIntro: "We serve all Fayetteville neighborhoods and the surrounding Sandhills area including Hope Mills, Spring Lake, Fort Liberty, Raeford, Stedman, Wade, Eastover, Linden, Autryville, Parkton, and Lumberton. If you are anywhere in Cumberland, Hoke, or Robeson counties, we have you covered.",
  howItWorksIntro: "Most Fayetteville travelers complete everything online and ship documents overnight. No need to drive to Washington DC or wait in line at the regional agency.",
  mistakesIntro: "Fayetteville travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Fayetteville and Fort Liberty area travelers trust us when their deployment or departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Fayetteville? Here are the most common ones we hear from Cumberland County travelers.",
  statePageRoute: "/states/north-carolina",
  statePageName: "North Carolina",
  dmvWebsite: "https://www.ncdot.gov",
  dmvLabel: "North Carolina DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Fayetteville international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Sgt. Marcus H.",
      location: "Fort Liberty, NC",
      rating: 5,
      text: "Deployment orders came with 48 hours notice. Fast Passport Center got my emergency passport ready in 24 hours. They understand the urgency military families face. Outstanding service.",
      service: "Emergency Passport",
    },
    {
      name: "Jennifer W.",
      location: "Fayetteville, NC",
      rating: 5,
      text: "Family emergency in Germany and my passport was expired. They had my renewal in 36 hours. I never had to leave Fayetteville. The team was compassionate and professional.",
      service: "Passport Renewal",
    },
    {
      name: "David C.",
      location: "Hope Mills, NC",
      rating: 5,
      text: "Business trip to Dubai came up with 6 days notice. Fast Passport Center got me a passport in 4 business days. The communication was excellent throughout the entire process.",
      service: "Emergency Passport",
    },
    {
      name: "Sarah M.",
      location: "Spring Lake, NC",
      rating: 5,
      text: "First passport for my son before his school trip to Italy. Fast Passport Center helped us navigate every document. Ready in 5 days with zero stress. Truly grateful.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "fayetteville-1",
      name: "Fayetteville Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "300 Green St",
      city: "Fayetteville",
      state: "NC",
      zip: "28301",
      phone: "(910) 485-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Fayetteville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Fayetteville facility. High volume — appointments strongly recommended. Call ahead to confirm passport acceptance.",
      icon: "ri-mail-line",
    },
    {
      id: "fayetteville-2",
      name: "Hope Mills Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "4487 Main St",
      city: "Hope Mills",
      state: "NC",
      zip: "28348",
      phone: "(910) 425-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "South Fayetteville suburb",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Hope Mills and south Fayetteville residents. Less crowded than downtown.",
      icon: "ri-mail-line",
    },
    {
      id: "fayetteville-3",
      name: "Spring Lake Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "71 2nd St",
      city: "Spring Lake",
      state: "NC",
      zip: "28390",
      phone: "(910) 436-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "North Fayetteville, Fort Liberty area",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Spring Lake and Fort Liberty area. Full passport services. Appointments required.",
      icon: "ri-mail-line",
    },
    {
      id: "fayetteville-4",
      name: "Raeford Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "125 E Central Ave",
      city: "Raeford",
      state: "NC",
      zip: "28376",
      phone: "(910) 875-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "West Fayetteville, Hoke County",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Hoke County and west Fayetteville area. Call for appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "fayetteville-5",
      name: "Cumberland County Clerk of Court",
      type: "Court Clerk Passport Acceptance",
      address: "117 Dick St",
      city: "Fayetteville",
      state: "NC",
      zip: "28301",
      phone: "(910) 678-2900",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Cumberland County Courthouse, downtown Fayetteville",
      website: "https://www.cumberlandcountync.gov/",
      websiteLabel: "Cumberland County Clerk",
      notes: "Accepts passport applications. Good alternative to post office with extended hours. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "fayetteville-6",
      name: "Fort Liberty Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Bldg 4-2841",
      city: "Fort Liberty",
      state: "NC",
      zip: "28310",
      phone: "(910) 396-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Fort Liberty military base",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves military personnel and families on Fort Liberty. ID required for base access.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 5 hour drive to Washington DC", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Fayetteville photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Cumberland County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Fayetteville applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Cumberland County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Fayetteville travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Fayetteville." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Fayetteville address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Fayetteville before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Fayetteville for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 5 hour drive to Washington DC." },
    { q: "How fast can I renew my passport in Fayetteville?", a: "Fast Passport Center offers fast passport renewal in Fayetteville in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Fayetteville?", a: "The nearest regional passport agency to Fayetteville is the Washington DC Passport Agency at 600 19th St NW, Washington DC 20006, approximately 320 miles north via I-95. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Fayetteville without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Fayetteville?", a: "Same-day passport appointments are only available at the Washington DC Passport Agency — approximately 5 hours from Fayetteville — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Cumberland County residents." },
    { q: "Do you serve military families at Fort Liberty?", a: "Absolutely. Fast Passport Center proudly serves military families at Fort Liberty and throughout the Fayetteville area. We understand the unique urgency of deployment and PCS travel. Our courier service works seamlessly from any address on or off base in Cumberland and Hoke counties." },
    { q: "Can I expedite a child passport in Fayetteville?", a: "Yes. Fast Passport Center expedites child passports in Fayetteville for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Cumberland County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Fayetteville with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Washington DC Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Fayetteville", address: "3050 N Main St, Fayetteville, NC 28305", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/store-locator" },
    { name: "Walgreens — Fayetteville", address: "4721 Ramsey St, Fayetteville, NC 28311", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/storelocator" },
    { name: "Walmart Supercenter — Fayetteville", address: "4601 Ramsey St, Fayetteville, NC 28311", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/store/finder" },
    { name: "FedEx Office — Fayetteville", address: "1931 Skibo Rd, Fayetteville, NC 28314", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.fedex.com/en-us/location.html" },
    { name: "CVS Pharmacy — Hope Mills", address: "3200 N Main St, Hope Mills, NC 28348", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/store-locator" },
    { name: "Walgreens — Spring Lake", address: "1300 N Main St, Spring Lake, NC 28390", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/storelocator" },
    { name: "CVS Pharmacy — Raeford", address: "125 E Central Ave, Raeford, NC 28376", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/store-locator" },
    { name: "Walmart — Lumberton", address: "5070 Fayetteville Rd, Lumberton, NC 28358", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/store/finder" },
  ],
  dmvLocations: [
    {
      name: "NC DMV — Fayetteville",
      address: "3426 Bragg Blvd, Fayetteville, NC 28303",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "NC DMV — Hope Mills",
      address: "4457 Main St, Hope Mills, NC 28348",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "NC DMV — Spring Lake",
      address: "71 2nd St, Spring Lake, NC 28390",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Fort Liberty and north Cumberland County residents. REAL ID available.",
      featured: false,
    },
    {
      name: "NC DMV — Raeford",
      address: "125 E Central Ave, Raeford, NC 28376",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Hoke County and west Cumberland County. REAL ID available.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "FAY",
      name: "Fayetteville Regional Airport",
      distance: "4 miles south of downtown Fayetteville",
      address: "400 Airport Rd, Fayetteville, NC 28306",
      note: "Primary airport for Fayetteville and the Sandhills region. Direct flights to major domestic hubs. American Airlines service with connections to international destinations.",
      flightUrl: "https://www.fayobserver.com/fayairport/",
      flightLabel: "FAY Airport",
      featured: true,
    },
    {
      code: "RDU",
      name: "Raleigh-Durham International Airport",
      distance: "60 miles north of Fayetteville",
      address: "2400 John Brantley Blvd, Morrisville, NC 27560",
      note: "Major international hub with direct flights to London, Paris, and Cancun. Consider for long-haul international travel from the Sandhills region.",
      flightUrl: "https://www.rdu.com/",
      flightLabel: "RDU Airport",
      featured: false,
    },
    {
      code: "ILM",
      name: "Wilmington International Airport",
      distance: "90 miles east of Fayetteville",
      address: "1740 Airport Blvd, Wilmington, NC 28405",
      note: "Alternative airport for coastal and eastern Cumberland County travelers. Additional domestic routes.",
      flightUrl: "https://www.flyilm.com/",
      flightLabel: "ILM Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      label: 'North Carolina Vital Records (NCDHHS)',
      description: 'Birth and death certificates for all NC counties. Order online, by mail, or in person at the Raleigh office.',
      url: 'https://vitalrecords.nc.gov/',
    },
    {
      label: 'Cumberland County Register of Deeds',
      description: 'Marriage licenses and records for Cumberland County. Apply in person or request certified copies.',
      url: 'https://www.cumberlandcountync.gov/departments/register-of-deeds',
    },
    {
      label: 'Cumberland County Clerk of Superior Court',
      description: 'Divorce records and decrees for Cumberland County. Contact the clerk for certified copies.',
      url: 'https://www.nccourts.gov/locations/cumberland-county/cumberland-county-clerk-of-superior-court',
    },
  ],
};